import styled from 'styled-components';

export const DateRow = styled.div`
    display: flex;
    align-items: center;
`;

export const CalendarEvent = styled.div`
    width: 100%;
    height: 100%;
    background-color: #3e3e3e;
    padding: 5px;
    outline: 1px solid #8d8d8d;
    outline-offset: -1px;
    cursor: pointer;

    &:hover {
        background-color: #2f2f2f;
    }

    transition: all 0.25s;
`;

export const HeaderCellContainer = styled.div`
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: white;
    font-weight: 300;
`;

export const TodayIndicator = styled.div`
    width: 80px;
    height: 20px;
    border-radius: 11px;
    background-image: linear-gradient(to bottom, #fb711c, #fa2e58);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
`;

export const WeekChallengeButton = styled.div`
    height: 25px;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.1);
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
        background-color: rgba(255, 255, 255, 0.4);
    }
`;

export const WeekChallengeContainer = styled.div`
    width: 170px;
    // height: 25px;
`;

export const DaySummaryRow = styled.div`
    // display: flex;
    // justify-content: flex-end;
    position: absolute;
    top: 102px;
    left: 238px;
    // padding: 0 16px 0 66px;
    border-top: 1px solid #6e6e6e;
    border-bottom: 2px solid #6e6e6e;
    z-index: 10000;
`;

export const Summary = styled.div`
    width: ${props => (props.width ? props.width : '100%')};
    height: ${props => (props.height ? props.height : '30px')};
    display: flex;
`;

export const SummaryCell = styled.div`
    width: ${props => (props.width ? props.width : 'auto')};
    height: ${props => (props.height ? props.height : '30px')};
    border-right: 1px solid #6e6e6e;
    overflow: hidden;
`;

export const WorkoutOfTheDayContainer = styled.div`
    width: 100%;
    overflow: hidden;
    height: 30px;
    background-color: rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid #6e6e6e;
    display: flex;
    align-items: center;
    padding: 0 8px;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
        background-color: rgba(255, 255, 255, 0.4);
    }
`;

export const BdayContainer = styled.div`
    width: 100%;
    overflow: hidden;
    height: 40px;
    background-color: ${props => (props.isFilled ? 'rgba(255, 255, 255, 0.1)' : 'none')};
    border-bottom: 1px solid #6e6e6e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px;
    cursor: ${props => (props.isFilled ? 'pointer' : 'default')};
    transition: all 0.25s;

    &:hover {
        ${props => props.isFilled && 'background-color: rgba(255, 255, 255, 0.4)'};
    }
`;

export const FirstCell = styled.div`
    width: 48px;
    height: ${props => (props.height ? props.height : '30px')};
    background-color: #0e0e0e;
`;

export const WOD = styled.div`
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AllDay = styled(WOD)`
    border-bottom: 1px solid #6e6e6e;
    height: 40px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/style.js